<template>
  <fragment>
    <v-row
      align="center"
      justify="center"
      class="overflow-hidden"
      v-if="mdAndUp"
    >
      <v-col cols="6" class="pa-0">
        <v-img
          height="100vh"
          src="/playground_assets/vertical.png"
          class="d-flex flex-row align-center"
        >
          <v-row>
            <v-col cols="12" sm="12" md="12" class="eleven-logo-container pb-0">
              <v-img
                :aspect-ratio="16 / 9"
                src="/playground_assets/Eleven_Tickets_Negativo_Horizontal.svg"
                width="250"
                height="58"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="step > 1">
              <v-btn icon absolute top left @click="step--" class="white ml-4">
                <v-icon color="black">mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="d-flex flex-row justify-center align-center">
            <v-spacer></v-spacer>
            <v-col md="9" lg="7">
              <v-window class="login-window" v-model="step">
                <v-window-item :value="1">
                  <v-card elevation="2" class="rounded-xl" height="100%">
                    <v-card-text>
                      <v-form
                        @submit.prevent="logIn"
                        class="d-flex flex-column align-center pa-4"
                        ref="loginForm"
                        lazy-validation
                      >
                        <v-btn-toggle
                          v-model="login.tipo_usuario"
                          dense
                          borderless
                          mandatory
                          class="rounded-lg"
                          style="display: flex; justify-content: center"
                          color="tertiary"
                        >
                          <v-btn value="admin_afiliado"> Afiliado </v-btn>
                          <v-btn value="admin_lojista"> Produtor </v-btn>
                          <v-btn value="admin_eleven"> Usuário Eleven </v-btn>
                        </v-btn-toggle>
                        <template v-if="loginTypeShopekeeper">
                          <BaseTextField
                            label="Loja"
                            placeholder="Insira o sequenciador da loja"
                            v-model="login.loja"
                            type="number"
                            class="mt-7"
                            :rules="[rules.required]"
                          />
                        </template>
                        <BaseTextField
                          label="E-mail"
                          placeholder="johndoe@example.com"
                          class="mt-7"
                          v-model="login.email"
                          type="email"
                          :rules="[rules.required, rules.email]"
                        />
                        <BaseTextField
                          label="Senha"
                          placeholder="******"
                          class="mt-7"
                          v-model="login.senha"
                          :type="typePassword"
                          :append-icon="typePasswordIcon"
                          :rules="[rules.required]"
                          @click:append="login.showSenha = !login.showSenha"
                        />
                        <v-btn
                          text
                          x-small
                          class="pl-2 primary--text mt-2"
                          @click="step++"
                          >Esqueci minha senha</v-btn
                        >
                        <v-col
                          v-if="
                            ($pessoas_usuarios.qr_code ||
                              $pessoas_usuarios.send_mfa) &&
                            login.tipo_usuario === 'admin_eleven'
                          "
                          class="d-flex flex-column align-center"
                        >
                          <h2>
                            {{
                              $t(
                                "common.password-requirements.mfa-authentication"
                              )
                            }}
                          </h2>
                          <h4 v-if="$pessoas_usuarios.qr_code" class="mt-4">
                            {{
                              $t(
                                "common.password-requirements.activate-mfa-authentication"
                              )
                            }}
                          </h4>
                          <v-img
                            width="200px"
                            class="mt-4"
                            v-if="$pessoas_usuarios.qr_code"
                            :src="$pessoas_usuarios.qr_code"
                            :lazy-src="$pessoas_usuarios.qr_code"
                            alt="QR Code"
                          />
                          <h5 class="mt-4">
                            {{
                              $t("common.password-requirements.insert-mfa-code")
                            }}
                          </h5>
                          <BaseTextField
                            :label="$t('common.password-requirements.mfa-code')"
                            type="number"
                            class="mt-4"
                            v-model="mfa"
                            hide-spin-buttons
                            @wheel.prevent
                            style="max-width: 200px"
                            maxLength="6"
                          />
                        </v-col>
                        <v-btn
                          class="rounded-lg mt-7"
                          color="tertiary"
                          dark
                          block
                          tile
                          type="submit"
                          data-cy="Entrar"
                          :loading="loginLoading"
                          >Entrar</v-btn
                        >
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-window-item>
                <v-window-item :value="2">
                  <v-card elevation="2" class="rounded-xl">
                    <v-card-text>
                      <v-form
                        @submit.prevent="recoveryPassword"
                        class="d-flex flex-column align-center"
                        ref="recoveryForm"
                        lazy-validation
                      >
                        <v-btn-toggle
                          v-model="login.tipo_usuario"
                          dense
                          borderless
                          mandatory
                          class="rounded-lg mt-7"
                          color="tertiary"
                        >
                          <v-btn value="admin_afiliado"> Afiliado </v-btn>
                          <v-btn value="admin_lojista"> Produtor </v-btn>
                          <v-btn value="admin_eleven"> Usuário Eleven </v-btn>
                        </v-btn-toggle>
                        <template v-if="loginTypeShopekeeper">
                          <BaseTextField
                            label="Loja"
                            placeholder="Insira o sequenciador da loja"
                            v-model="login.loja"
                            type="number"
                            class="mt-7"
                            :rules="[rules.required]"
                          />
                        </template>
                        <BaseTextField
                          label="E-mail"
                          placeholder="johndoe@example.com"
                          class="mt-7"
                          v-model="recovery.email"
                          type="email"
                          @input="lowerCaseEmail"
                          :rules="[rules.required, rules.email]"
                        />
                        <v-btn
                          :loading="$pessoas_usuarios.recovery_loading"
                          class="rounded-lg mt-7"
                          color="tertiary"
                          dark
                          block
                          tile
                          type="submit"
                        >
                          Recuperar
                        </v-btn>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-window-item>
              </v-window>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
        </v-img>
      </v-col>
      <v-col
        cols="6"
        class="secondary d-flex flex-column align-center justify-center pa-0"
      >
        <v-card-text
          class="white--text text-center d-flex flex-column align-center justify-center"
        >
          <v-img
            src="/playground_assets/login-eleventickets.png"
            alt="ElevenTickets"
          />
        </v-card-text>
      </v-col>
    </v-row>

    <v-container class="eleven-container ma-0 pa-0" v-else>
      <v-container class="eleven-bg-container d-flex align-end pa-0">
        <v-btn icon absolute top left dark v-if="step > 1" @click="step--">
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>

        <v-row
          class="flex-column justify-between"
          style="height: 100%; width: 100%"
        >
          <v-col class="d-flex justify-center align-center">
            <v-img
              src="/playground_assets/Eleven_Tickets_Negativo_Horizontal.svg"
              max-height="57"
              max-width="255"
            ></v-img>
          </v-col>

          <v-col class="d-flex align-end">
            <v-window v-model="step" class="mobile-login-window">
              <v-window-item :value="1">
                <v-card elevation="2" class="rounded-t-xl">
                  <v-card-text class="d-flex align-center justify-center">
                    <v-form
                      @submit.prevent="logIn"
                      class="d-flex flex-column align-center pa-4"
                      style="width: 100%"
                      ref="loginForm"
                      lazy-validation
                    >
                      <v-btn-toggle
                        v-model="login.tipo_usuario"
                        dense
                        borderless
                        mandatory
                        class="rounded-lg"
                        color="tertiary"
                        style="display: flex; justify-content: center"
                      >
                        <v-btn value="admin_afiliado"> Afiliado </v-btn>
                        <v-btn value="admin_lojista"> Produtor </v-btn>
                        <v-btn value="admin_eleven"> Usuário Eleven </v-btn>
                      </v-btn-toggle>
                      <template v-if="loginTypeShopekeeper">
                        <BaseTextField
                          label="Loja"
                          placeholder="Insira o sequenciador da loja"
                          v-model="login.loja"
                          type="number"
                          class="mt-7"
                          :rules="[rules.required]"
                        />
                      </template>
                      <BaseTextField
                        label="E-mail"
                        placeholder="johndoe@example.com"
                        class="mt-7"
                        v-model="login.email"
                        type="email"
                        :rules="[rules.required, rules.email]"
                      />
                      <BaseTextField
                        label="Senha"
                        placeholder="******"
                        class="mt-7"
                        v-model="login.senha"
                        :type="typePassword"
                        :append-icon="typePasswordIcon"
                        :rules="[rules.required]"
                        @click:append="login.showSenha = !login.showSenha"
                      />
                      <v-btn
                        text
                        x-small
                        class="pl-2 primary--text mt-2"
                        @click="step++"
                        >Esqueci minha senha</v-btn
                      >

                      <v-col
                        v-if="
                          ($pessoas_usuarios.qr_code ||
                            $pessoas_usuarios.send_mfa) &&
                          login.tipo_usuario === 'admin_eleven'
                        "
                        class="d-flex flex-column align-center"
                      >
                        <h3>
                          {{
                            $t(
                              "common.password-requirements.mfa-authentication"
                            )
                          }}
                        </h3>
                        <h5 v-if="$pessoas_usuarios.qr_code" class="mt-4">
                          {{
                            $t(
                              "common.password-requirements.activate-mfa-authentication"
                            )
                          }}
                        </h5>
                        <v-img
                          width="150px"
                          class="mt-4"
                          v-if="$pessoas_usuarios.qr_code"
                          :src="$pessoas_usuarios.qr_code"
                          :lazy-src="$pessoas_usuarios.qr_code"
                          alt="QR Code"
                        />
                        <h5 class="mt-4">
                          {{
                            $t("common.password-requirements.insert-mfa-code")
                          }}
                        </h5>
                        <BaseTextField
                          :label="$t('common.password-requirements.mfa-code')"
                          type="number"
                          class="mt-4"
                          v-model="mfa"
                          hide-spin-buttons
                          @wheel.prevent
                          style="max-width: 200px"
                          maxLength="6"
                        />
                      </v-col>

                      <v-btn
                        class="rounded-lg mt-4"
                        color="tertiary"
                        dark
                        block
                        tile
                        type="submit"
                        data-cy="Entrar"
                        :loading="loginLoading"
                        >Entrar</v-btn
                      >
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-window-item>
              <v-window-item :value="2" style="max-width: 100vw">
                <v-card elevation="2" class="rounded-t-xl">
                  <v-card-text>
                    <v-form
                      @submit.prevent="recoveryPassword"
                      class="d-flex flex-column align-center pa-4"
                      ref="recoveryForm"
                      lazy-validation
                    >
                      <v-btn-toggle
                        v-model="login.tipo_usuario"
                        dense
                        borderless
                        mandatory
                        class="rounded-lg"
                        color="tertiary"
                      >
                        <v-btn value="admin_afiliado"> Afiliado </v-btn>
                        <v-btn value="admin_lojista"> Produtor </v-btn>
                        <v-btn value="admin_eleven"> Usuário Eleven </v-btn>
                      </v-btn-toggle>
                      <template
                        v-if="loginTypeShopekeeper"
                        style="max-width: 100%"
                      >
                        <BaseTextField
                          label="Loja"
                          placeholder="Insira o sequenciador da loja"
                          v-model="login.loja"
                          type="number"
                          class="mt-7"
                          :rules="[rules.required]"
                        />
                      </template>
                      <BaseTextField
                        label="E-mail"
                        placeholder="johndoe@example.com"
                        class="mt-7"
                        v-model="recovery.email"
                        @input="lowerCaseEmail"
                        type="email"
                        :rules="[rules.required, rules.email]"
                      />
                      <v-btn
                        :loading="$pessoas_usuarios.recovery_loading"
                        class="rounded-lg mt-7"
                        color="tertiary"
                        dark
                        block
                        tile
                        type="submit"
                      >
                        Recuperar
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <vue-recaptcha
      :language="'pt_br'"
      :key="recaptchaRenderKey"
      :sitekey="$config.site_key_recaptcha"
      @verify="executeRecaptcha"
      @expired="onCaptchaExpired"
      size="invisible"
      :loadRecaptchaScript="true"
      v-if="productionEnvironment"
    >
    </vue-recaptcha>
  </fragment>
</template>
<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
import formRules from "@/mixins/formRules";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import VueRecaptcha from "vue-recaptcha";
import { mapActions } from "vuex";
import mixins from "@/mixins";

const { recaptcha } = mixins;

export default {
  name: "Login",
  mixins: [displayHelpers, formRules, recaptcha],
  metaInfo: {
    title: "Login | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Login | ElevenTickets",
      },
    ],
  },
  components: {
    BaseTextField,
    VueRecaptcha,
  },
  data() {
    return {
      step: 1,
      recaptchaRenderKey: 0,
      login: {
        tipo_usuario: "admin_lojista",
        loja: "",
        email: "",
        senha: "",
        mfa: "",
        esqueciSenha: false,
        showSenha: false,
      },
      recovery: {
        email: "",
      },
    };
  },
  watch: {
    "login.tipo_usuario"(e) {
      if (e === "admin_lojista") {
        this.login.userIsLojista = true;
        this.$config.user_type = "admin";
        return;
      }
      this.$config.user_type = "loja";
      return (this.login.userIsLojista = false);
    },
  },
  mounted() {
    setTimeout(() => {
      this.recaptchaRenderKey = this.recaptchaRenderKey + 1;
    }, 5000);
  },
  computed: {
    productionEnvironment() {
      return process.env.NODE_ENV === "production";
    },
    typePassword() {
      return this.login.showSenha ? "text" : "password";
    },
    typePasswordIcon() {
      return this.login.showSenha ? "mdi-eye-off" : "mdi-eye";
    },
    loginLoading() {
      if (this.login.tipo_usuario === "admin_lojista") {
        return this.$lojas_usuarios.cadastro.loading;
      }
      return this.$pessoas_usuarios.cadastro.loading;
    },
    loginTypeShopekeeper() {
      return this.login.tipo_usuario === "admin_lojista";
    },
  },
  methods: {
    ...mapActions(["logInAffiliate", "sendEmailRecoverPassword"]),
    lowerCaseEmail() {
      this.recovery.email = this.recovery.email.toLowerCase();
    },
    async recoveryPassword() {
      if (!this.$refs.recoveryForm.validate()) return;

      if (this.productionEnvironment) {
        await this.executeRecaptcha();
        if ((await window.grecaptcha.getResponse()) == "") return;
      }

      switch (this.login.tipo_usuario) {
        case "admin_eleven":
          this.$pessoas_usuarios.recuperarSenha(this.recovery.email);
          break;
        case "admin_lojista":
          this.$lojas_usuarios.recuperarSenha(
            this.recovery.email,
            this.login.loja
          );
          break;
        case "admin_afiliado":
          this.sendEmailRecoverPassword({
            email: this.recovery.email,
            url: process.env.VUE_APP_PANEL_URL + "recuperar-senha-afiliado",
          });
          break;
      }
    },
    async logIn() {
      if (!this.$refs.loginForm.validate()) return;

      if (this.productionEnvironment) {
        await this.executeRecaptcha();
        if ((await window.grecaptcha.getResponse()) == "") return;
      }

      switch (this.login.tipo_usuario) {
        case "admin_eleven":
          this.$pessoas_usuarios.getLogin(
            true,
            this.login.email,
            this.login.senha,
            "",
            this.mfa
          );
          break;
        case "admin_lojista":
          this.$lojas_usuarios.getLogin(
            true,
            this.login.email,
            this.login.senha,
            this.login.loja,
            ""
          );
          break;
        case "admin_afiliado":
          this.logInAffiliate({
            email: this.login.email,
            senha: this.login.senha,
          });
          break;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.eleven-container {
  min-height: calc(100% + 50px);
  background-color: #322357;
}
.eleven-bg-container {
  height: 100svh;
  background-image: url("/playground_assets/vertical.png");
  background-color: #322357;
  background-size: cover;
}
.eleven-logo-container {
  height: 100%;
  display: grid;
  justify-content: center;
}

.login-window {
  overflow-y: auto !important;
  max-height: 95vh;
}

.mobile-login-window {
  width: 100%;
  overflow-y: auto !important;
  max-height: 80vh;
}
</style>
